import { _,moment } from '../../vendor'
import { FormatHelper } from '../utils'
import Resources from '../collections/Resources'

import InboomaBaseModel from './InboomaBaseModel'

export default InboomaBaseModel.extend({

  urlRoot : '/contingents',

  initialize () {
      this.clearFormat();
  },

  clearFormat() {

      // Remove noisy attributes
      this.set('resources', new Resources(this.get('resources')));

      if (typeof this.get('_joinData') !== 'undefined') {
          delete this.attributes._joinData;
      }

      delete this.attributes.calendars;

      if(this.attributes.fe_visible == 1){
          this.set('fe_visible',true);
      } else {
          this.set('fe_visible',false);
      }

      return this;

  },

  validate (attrs) {
      if (attrs.locations.length === 0) {
          return "one_location_required"
      }
  },

  /**
   * Return amount of available resources for today
   * 
   * @return {object} see below
   */
  getNumbersByToday () {
      return this.getNumbersByDay(moment().hours(0).minutes(0).seconds(0).milliseconds(0));
  },

  getFormattedTags () {
      return FormatHelper.formatContingentTags(this.get('tags'));
  },

  /**
   * Return amount of available resources on a specific day
   * 
   * @param {String|Moment} day
   * @return {object} w/ attributes id, contingent_id, number, valid_from
   */
  getNumbersByDay (day) {

    if (typeof day === 'string') {
        day = moment(day);
    }

    let result;

    _.each(this.get('contingent_numbers'), function(numberObj, __) {

        const valid_from = moment(numberObj.valid_from);

        if (valid_from.isSameOrBefore(day)) {
            if (typeof result !== 'undefined') {
              // Compare with previous valid_from
              if (moment(result.valid_from).isAfter(valid_from)) {
                  return;
              }
            }

            result = numberObj;
        }
    });

    return result;
  },

  _rbac : {
    "admin" : {
      "read" : true,
      "write" : true,
      "edit" : true,
      "remove" : true,
      "manage-prices" : true,
    },
    "user" : {
      "read" : false,
      "write" : false,
      "edit" : false,
      "remove" : false,
      "manage-prices" : false,
    },
    "garage-staff" : {
      "read" : true,
      "write" : false,
      "edit" : false,
      "remove" : false,
      "manage-prices" : false,
    },
    "manager" : {
      "read" : true,
      "write" : true,
      "edit" : true,
      "remove" : true,
      "manage-prices" : true,
    },
    "manager-location" : {
      "read" : true,
      "write" : false,
      "edit" : false,
      "remove" : false,
      "manage-prices" : false,
    },
    "booking-manager" : {
      "read" : false,
      "write" : false,
      "edit" : false,
      "remove" : false,
      "manage-prices" : false,
    },
  },

  defaults : {
      id : "",
      client_id : "",
      resourcetype_id : "",
      name : "",
      description : "",
      picture : " ",
      resources : [],
      locations : [],
      contingent_numbers : [],
      fe_visible : 1,
      created : "",
      created_by : "",
      modified : "",
      modified_by : "",
      deleted : ""
  }
});